import React from "react";
import "./Dashboard.css";
import HeaderBar from "../../components/HeaderBar";

const Dashboard = () => {
  return (
    <div className="outerContainer">
      <div className="container">
        <HeaderBar delay={0.5} />
        <div className="dashboardContainer">
          <div className="innerContainer">
            <div className="dashboardAbs">1</div>
            <div className="inner">
              <h1>Hello world</h1>
              <p>Lorem ipus ifakfjsafklsaj ashsadiufh</p>
            </div>
          </div>

          <div className="innerContainer">
            <div className="dashboardAbs">2</div>
            <div className="inner">
              <h1>Hello world</h1>
              <p>Lorem ipus ifakfjsafklsaj ashsadiufh</p>
            </div>
          </div>

          <div className="innerContainer">
            <div className="dashboardAbs">3</div>
            <div className="inner">
              <h1>Hello world</h1>
              <p>Lorem ipus ifakfjsafklsaj ashsadiufh</p>
            </div>
          </div>

          <div className="innerContainer">
            <div className="dashboardAbs">4</div>
            <div className="inner">
              <h1>Hello world</h1>
              <p>Lorem ipus ifakfjsafklsaj ashsadiufh</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
